// ----------------------------------------------------------------------
// <copyright file="Izenda.Cookies.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import Cookies from 'js-cookie';
import { extend, defaults } from 'lodash/fp';
import SettingConstants from 'logic/data/Izenda.SettingConstants';

let defaultOptions = {
  sameSite: SettingConstants.COOKIES.SAMESITE.LAX,
  secure: false
};

export default {
  /**
   * Set default options
   * @param {Object} options 
   */
  setDefaultOptions(options) {
    defaultOptions = extend(defaultOptions, options);
  },

  /**
   * Get cookie
   * @param {String} key
   * @returns {Object} Cookie
   */
  get(key) {
    return Cookies.get(key);
  },

  /**
   * Set cookie
   * @param {String} key
   * @param {Object} value
   * @param {Object} options
   */
  set(key, value, options) {
    Cookies.set(key, value, defaults(defaultOptions, options));
  },

  /**
   * Remove cookie
   * @param  {String} key
   * @param  {Object} options
   */
  remove(key, options) {
    Cookies.remove(key, options);
  }
};



// WEBPACK FOOTER //
// ./ui/Izenda.Cookies.js